/** biome-ignore-all lint/style/useNamingConvention: <Use error codes as keys> */
import type TranslationsConfigType from './translation-type';

const nbTranslations: TranslationsConfigType = {
    homeButton: {
        ariaLabel: 'Gå tilbake til fondssparing til barn',
        goToSaving: 'Fondssparing til barn',
        goToBank: 'Nettbank',
    },
    tryAgain: 'Prøv igjen',
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
        errorCode: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
    },
    errorCode: {
        SPARING_CHILD_ACCOUNT_WEB_INTERNAL_ERROR: 'Intern feil',
        SPARING_CHILD_ACCOUNT_WEB_UNAUTHORIZED: 'Ikke autorisert',
        SPARING_CHILD_ACCOUNT_WEB_MANDATORY_FIELD_IS_MISSING: 'Påkrevd felt mangler',
        SPARING_CHILD_ACCOUNT_WEB_NOT_SUPPORTED: 'Ikke støttet',

        SPARING_CUSTOMER_ONBOARDING_MS_WS_INTERNAL_ERROR: 'Intern feil',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_UNAUTHORIZED: 'Ikke autorisert',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_NOT_SUPPORTED: 'Ikke støttet',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_NOT_FOUND:
            'Prosess ikke funnet',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_ALREADY_EXISTS:
            'Det finnes allerede en pågående prosess for dette barnet. Vennligst gå til oversikten for å fortsette.',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_ALREADY_EXISTS:
            'Aksjesparekonto for barnet eksisterer allerede',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CREATE_SHARE_SAVINGS_ACCOUNT_FOR_CHILD_PROCESS_ALREADY_FINISHED:
            'Prosessen er allerede fullført',

        SPARING_CUSTOMER_ONBOARDING_MS_WS_BANKREGNR_NOT_SET: 'Bankregisternummer ikke satt',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CHILD_IS_NOT_A_MINOR: 'Barnet er ikke mindreårig',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_CONFIG_FILE_PARSE_ERROR: 'Feil ved lesing av konfigurasjonsfil',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_DECEASED_PERSON_NOT_SUPPORTED: 'Avdød person ikke støttet',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PARENTS_ARE_NOT_VALID: 'Foreldre er ikke gyldige',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_NOTIFICATION_MESSAGE_PARAMETER_MISSING:
            'Mangler parameter i varslingsmelding',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PORTFOLIO_CREATION_IN_TRADEX_FAILED: 'Opprettelse av portefølje feilet',
        SPARING_CUSTOMER_ONBOARDING_MS_WS_PERSON_HAS_FALSE_IDENTITY: 'Person har falsk identitet',
    },
    header: 'Aksjespare\u00ADkonto i barnets navn',
    tip: 'Tips',
    ok: 'Ok',
    next: 'Neste',
    accept: 'Godkjenn',
    ingress: 'Hei{}. Her kan du enkelt opprette aksjespare\u00ADkontoer for barn og få oversikt over dine oppgaver.',
    backToOverview: 'Tilbake til oversikt',
    listOfChildren: {
        header: 'Barn',
        noChildrenHeader: 'Vi fant ingen barn registrert på deg som du kan opprette aksjesparekonto for.',
        noChildrenIngress:
            'Aksjespare\u00ADkonto i barnets navn kan kun opprettes av foreldre med registrert foreldre\u00ADansvar for barn under 18 år. Tjenesten støtter foreløpig dessverre ikke opprettelse for ene\u00ADforsørgere.',
        noChildrenTips:
            'Dersom du ønsker å spare i ditt eget navn, kan du opprette en ny aksjespare\u00ADkonto i Smartspar når du kjøper fond. Deretter kan du gi kontoen barnets navn, slik at det blir tydelig hvem du sparer for.',
        error: 'Det oppstod en liten feil \u2013 vi får dessverre ikke vist barn og opprettelsen av aksjespare\u00ADkonto akkurat nå. Vennligst prøv igjen senere, så skal alt være på plass.',
        onlyOneAccountAllowed:
            'Det er kun mulig å opprette én konto per barn her. Dersom du ønsker flere, kan du ta kontakt så hjelper vi deg gjerne.',
    },
    childCard: {
        noAsk: 'Har ikke aksjespare\u00ADkonto.',
        createAsk: 'Opprett aksjespare\u00ADkonto',
        createAskFor: 'Opprett aksjespare\u00ADkonto for {}',
        giveConsent: 'Se over og godkjenn',
        goToStatus: 'Se status',
        goToCompleteStatus: 'Se detaljer',
        completeKYCForm: 'Fullfør nå',
        processInProgress: 'Under behandling',
        accountAlreadyExists: 'Har aktiv aksjespare\u00ADkonto.',
        waitingForApproverParentConsent: 'Venter på samtykke.',
        needsYourConsent: 'Venter på ditt samtykke.',
        incompleteProcess: 'Påbegynt opprettelse av aksjespare\u00ADkonto.',
        waitingForKYC: 'Kunde\u00ADkontroll mangler',
        pendingKYCAdvisorReview: 'Stoppet av kunde\u00ADkontrollen',
        ariaLabel: {
            processStatusFor: 'Status for eksisterende prosess: {}',
            childElement: 'Barn: {}',
            goToStatusFor: 'Se eksisterende prosess for {}',
            goToCompleteStatusFor: 'Se detaljer for {}',
            giveConsentFor: 'Se over og godkjenn for {}',
            completeKYCFormFor: 'Fullfør anti-hvitvask-skjema for {}',
            startSavingFor: 'Start sparingen for {}',
        },
    },
    usefulInfo: {
        header: 'Nyttig informasjon',
        aboutAskForChild: 'Om sparing i barnets navn',
        getAnOverviewOfTheSaving: 'Få oversikt over sparingen',
        howToCreateAManagedAccount: 'Slik opprettes aksjespare\u00ADkonto',
    },
    howToCreateInfo: {
        header: 'Slik opprettes aksjespare\u00ADkonto i barnets navn',
        ingress:
            'For å opprette, velger du hvilket barn som skal få en aksjespare\u00ADkonto, oppgir kontakt\u00ADinformasjon til den andre forelderen og godkjenner vilkår. Deretter vil vi sende en SMS til medforelderen for godkjenning.',
        item1: 'Velg hvilket barn som skal få aksjespare\u00ADkonto.',
        item2: 'Oppgi medforelders mobilnummer.',
        item3: 'Godkjenn vilkår og fyll ut kundekontroll for barnet.',
        item4: 'Medforelder logger inn og samtykker.',
        item5: 'Aksjespare\u00ADkontoen opprettes og dere kan starte sparingen.',
    },
    enterApproverParentInformation: {
        header: 'Medforelders kontaktinformasjon',
        ingress: 'Vi sender en SMS til medforelders mobilnummer for å få samtykke til å opprette konto for {}.',
        inputLabel: 'Mobilnummeret til {}',
        phoneValidationError: 'Vennligst oppgi et gyldig mobilnummer på 8 siffer',
    },
    processSummary: {
        header: 'Opp\u00ADsummering',
        accountOwner: 'Kontoeier',
        parents: 'Disponenter',
        mobileNrTo: 'Mobilnummer til',
        email: {
            subLabel: 'E-posten brukes til å sende deg kvittering når ny aksjespare\u00ADkonto er opprettet.',
            yourEmail: 'Din e-post',
            emptyEmailError: 'E-post\u00ADadressen må være utfylt',
            invalidEmailError: 'E-post\u00ADadressen er ikke gyldig',
        },
        documentConsent: {
            header: 'Les og godkjenn:',
            documentAvtaleOmAksjesparekonto: 'Avtale om aksjespare\u00ADkonto (pdf)',
            confirmationText: 'Jeg bekrefter å ha lest, forstått og akseptert innholdet i dokumentet.',
            youMustConfirmBeforeProceeding: 'Du må bekrefte innholdet i dokumentet før du kan fortsette',
            fetchingDocument: 'Henter dokument...',
            couldNotFetchDocument: 'Vi fikk ikke hentet dokumentet akkurat nå, vennligst prøv igjen senere.',
        },
        invalidProcessSubmitted: 'Ugyldig prosess sendt inn',
        postProcessError: 'Bestilling kunne ikke fullføres',
        postProcessErrorDescription:
            'Vi fikk dessverre ikke bestilt aksjespare\u00ADkontoen akkurat nå, vennligst prøv igjen senere.',
        ariaLabel: { infoHeader: 'Informasjon' },
    },
    pendingProcess: {
        header: {
            completed: 'Ny aksjespare\u00ADkonto er opprettet',
            inProgress: 'Ny aksjespare\u00ADkonto er under behandling',
        },
        details: {
            createdDate: 'Bestilt dato',
            accountOwner: 'Kontoeier',
            accountManagers: 'Disponenter',
            mobileNrTo: 'Mobilnummer til',
            approverParentPhoneNumber: 'medforelder {}',
            smsHasBeenSentTo: 'SMS sendt til',
            mobileIsMissing: 'Mangler mobilnummer',
            aboutAskLabel: 'Aksjespare\u00ADkonto for barn',
            aboutAskLinkText: 'Om produktet',
            partialAccessAge: 'Barnet får delvis tilgang og kan se fondene og spare mer selv.',
            handoverAge: 'Barnet får full tilgang og kan ta ut penger.',
            email: 'E-post for kvittering',
            emailIsMissing: 'Mangler e-post',
        },
        progress: {
            started: 'Påbegynt',
            stopped: 'Stoppet',
            registered: 'Registrert',
            consent: 'Samtykke',
            waitingForApproverParent: 'Venter på samtykke',
            complete: 'Fullført',
        },
        ariaLabel: {
            processStatus: 'Status for prosessen: {}',
            pageHeader: 'Status for prosessen for barn {}',
        },
        error: 'Vi kunne dessverre ikke vise prosessen akkurat nå, vennligst prøv igjen senere.',
        lastActivity: {
            label: 'Siste aktivitet:',
            waiting: {
                header: 'Du bestilte aksjespare\u00ADkonto',
                description:
                    'Før aksjespare\u00ADkontoen kan opprettes, må den andre forelderen samtykke. Dette kan den andre forelderen gjøre ved å gå til "Fondssparing til barn" på bankens hjemmeside.',
            },
            completed: {
                header: 'Aksjespare\u00ADkontoen er klar!',
                description:
                    'Barnet har fått en aksjespare\u00ADkonto. Dere kan nå begynne å spare i aksjefond for barnet i Smartspar.',
            },
            pending: {
                applicantParentHeader: 'Påbegynt aksjespare\u00ADkonto for {}',
                approverParentHeader: '{} har begynt å opprette aksjespare\u00ADkonto for {}',
                description: 'Kundekontrollen ble ikke fullført under opprettelse av aksjespare\u00ADkonto for barn',
            },
            advisorReview: {
                header: 'Kundekontrollen av {} må sjekkes av en rådgiver',
                description:
                    'Vennligst kontakt en rådgiver for å få behandlet saken din videre. Rådgiveren må se på saken din før aksjespare\u00ADkontoen kan opprettes.',
            },
            actions: {
                completeKYC: 'Fullfør nå',
                smartsparReadMore: 'Les om Smartspar',
            },
        },
        tag: 'Sparing i barnets navn',
    },
    processDetails: {
        header: 'Detaljer',
        headerAria: 'Detaljer om denne kontoopprettelsen',
        ageLimits: 'Aldersgrenser for barnet',
        peopleConnected: 'Tilknyttede personer',
        contactInfo: 'Kontakt\u00ADinformasjon',
    },
    approverParentConsent: {
        header: 'Godkjenn opprettelse av aksje\u00ADspare\u00ADkonto for {}',
        headerWithoutName: 'Godkjenn konto\u00ADopprettelse',
        ingress:
            '{} ønsker å opprette aksje\u00ADspare\u00ADkonto for {}. Denne opprettes bare dersom du samtykker til dette.',
        approveProcessError: 'Vi fikk ikke godkjent prosessen',
    },
    apiError: {
        processNotFoundHeader: 'Finner ikke prosess',
        processNotFoundIngress:
            'Vi kunne ikke finne prosessen du var ute etter. Vennligst dobbeltsjekk at du har valgt riktig prosess.',
        informationModalTitle: 'Bruk gjerne feilkoden når du kontakter oss',
        informationModalDescription:
            'Feilkoden hjelper oss med å raskt forstå hva som har gått galt, slik at du slipper å forklare alt selv. Du kan enkelt kopiere koden og lime den inn i e-posten eller meldingen du sender oss.',
    },
    savingLinks: {
        mobileAndOnlineBank: 'Mobilbank & nettbank',
        smartspar: 'Smartspar',
        eika: 'Eika.no',
        eit: 'Eika investortjenester',
    },
    success: {
        applicantParentSuccess: {
            header: 'Du er ferdig! Sparingen kan starte så snart den andre forelderen samtykker.',
            ingress:
                'Den andre forelderen må samtykke ved å logge inn på samme sted. Aksjespare\u00ADkontoen opprettes kun dersom den andre forelderen samtykker. Informasjon ble sendt på SMS til den andre forelderen.',
        },
        approverParentSuccess: {
            header: 'Du har gitt samtykke \u2013\n aksjespare\u00ADkontoen er klar!',
            ingress:
                'Barnet ditt har nå fått sin helt egen aksjespare\u00ADkonto. Kvittering for opprettelsen er tilgjengelig i e-posten din.',
            goToFundOverview: 'Gå til fondsoversikten',
        },
        smartspar: {
            title: 'Start sparingen i spare-appen',
            text: 'Barnets aksjespare\u00ADkonto er klar. Nå kan du enkelt starte fondssparing i Smartspar-appen.',
        },
    },
    stop: {
        header: 'Kundekontrollen må sjekkes av en rådgiver',
        ingress:
            'Vennligst kontakt en rådgiver for å få behandlet saken din videre. Rådgiveren må se på saken din før medforelder kan godkjenne at barnet får en aksjespare\u00ADkonto.',
    },
    smartspar: {
        readMore: 'Les om Smartspar',
        startSaving: 'Start sparingen',
    },
    accountForChildProductBullets: {
        header: 'Kort fortalt om produktet',
        bulletPoint: {
            bothParentsAccess: 'Begge foreldre har tilgang frem til barnet fyller {} år.',
            bothParentsApproval: 'Begge foreldre må godkjenne uttak fra barnets fond i denne perioden.',
            notPartOfEstate: 'Inngår ikke i boet ved skilsmisse/død.',
            lockedUntilHandover:
                'Barnet får delvis tilgang når det er 18 år. Barnet kan da fortsette sparingen selv og følge med på utviklingen i sine fond.',
            withdrawalsNotPossibleUntilHandover:
                'Uttak av penger vil være sperret for barnet inntil {} år. Foreldrene kan justere ned alder for uttak senere ved behov.',
            affectsScholarshipLink: 'Påvirker stipend',
            affectsScholarshipRest: 'ved totalbeløp over beløpsgrensen ({} i {}).',
            governorInvolvementLink: 'Statsforvalter kan involveres',
            governorInvolvementRest: 'ved totalbeløp over 2G ({} i {}).',
        },
        error: 'Vi fikk ikke vist informasjonen akkurat nå, vennligst prøv igjen senere.',
    },
    scholarshipDetails: {
        header: 'Barnets formue',
        ingress:
            'Hvis barnets formue overstiger grensebeløpet ({} i {}), kuttes stipendet fra Lånekassen. Les mer om regler hos Lånekassen:',
        linkText: 'Om formue på lånekassen.no',
        tip: 'Dette kan dere unngå ved å fortsette å spare i eget navn før formuesgrensen er nådd og overføre pengene etter at studiene er avsluttet.',
        error: 'Vi fikk ikke vist informasjonen akkurat nå, vennligst prøv igjen senere.',
    },
    governorAmountThresholdDetails: {
        over2gHeader: 'Over 2 G',
        over2gIngress:
            'Har barnet mer enn 2 G ({} i {}) i egen formue, kan statsforvalteren være med på å bestemme hvordan pengene spares.',
        uncommonHeader: 'Det er ikke vanlig',
        uncommonIngress:
            'Slik inngripen skjer stort sett dersom barnet arver et større beløp eller mottar en større forsikringsutbetaling.',
        tip: 'Slik inngripen kan dere unngå ved å fortsette å spare i eget navn før formuesgrensen er nådd.',
        error: 'Vi fikk ikke vist informasjonen akkurat nå, vennligst prøv igjen senere.',
    },
    aboutAccountForChildModal: {
        header: 'Om aksjespare\u00ADkonto for barn',
        ingress: 'Foreldre kan opprette aksjespare\u00ADkonto for barn under {}.',
    },
};

export default nbTranslations;
